export const decodeBase64Id = (encodedId: string): string => {
  if (!encodedId) return "";

  try {
    const decoded = atob(encodedId);

    const parts = decoded.split(":");
    if (parts.length === 2) {
      return parts[1];
    }

    return decoded;
  } catch (e) {
    console.error("Error decoding Base64 ID:", e);
    return encodedId;
  }
};
